/**
 * @fileoverview gRPC-Web generated client stub for legebill.site.v4
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.14.0
// source: legebill/site/v4/site.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as legebill_site_v4_site_pb from '../../../legebill/site/v4/site_pb';


export class SiteServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetSite = new grpcWeb.MethodDescriptor(
    '/legebill.site.v4.SiteService/GetSite',
    grpcWeb.MethodType.UNARY,
    legebill_site_v4_site_pb.GetSiteRequest,
    legebill_site_v4_site_pb.Site,
    (request: legebill_site_v4_site_pb.GetSiteRequest) => {
      return request.serializeBinary();
    },
    legebill_site_v4_site_pb.Site.deserializeBinary
  );

  getSite(
    request: legebill_site_v4_site_pb.GetSiteRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_v4_site_pb.Site>;

  getSite(
    request: legebill_site_v4_site_pb.GetSiteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_v4_site_pb.Site) => void): grpcWeb.ClientReadableStream<legebill_site_v4_site_pb.Site>;

  getSite(
    request: legebill_site_v4_site_pb.GetSiteRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_v4_site_pb.Site) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.v4.SiteService/GetSite',
        request,
        metadata || {},
        this.methodDescriptorGetSite,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.v4.SiteService/GetSite',
    request,
    metadata || {},
    this.methodDescriptorGetSite);
  }

}

